import { enums as highlights } from '../Highlights'

const highlightsIcons = highlights.reduce((icons, icon) => {
  try {
    icons[icon] = require(`./${icon}.svg`).default
  } catch (error) {
    // ignore non-existing files
  }
  return icons
}, {})

export default highlightsIcons
